import { isTryDockRunningSelector } from './selectors'
import { isThunk, FeedbotMiddleware } from '../../../types'
import { tryActions } from '../../../../store/dock/sections/try'

export const tryDockMiddleware: FeedbotMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    if (isThunk(action)) {
      return next(action)
    }

    const isTryDockRunning = isTryDockRunningSelector(getState())
    if (!isTryDockRunning && action.payload === 'TRY' && action.type === 'dock/toggleDock') {
      dispatch(tryActions.setIsRunning(true))
    }

    return next(action)
  }
